import { __extends } from "tslib";
import { ListEntityRecognizersRequest, ListEntityRecognizersResponse } from "../models/models_0";
import { deserializeAws_json1_1ListEntityRecognizersCommand, serializeAws_json1_1ListEntityRecognizersCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var ListEntityRecognizersCommand = /** @class */ (function (_super) {
    __extends(ListEntityRecognizersCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function ListEntityRecognizersCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    ListEntityRecognizersCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "ComprehendClient";
        var commandName = "ListEntityRecognizersCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: ListEntityRecognizersRequest.filterSensitiveLog,
            outputFilterSensitiveLog: ListEntityRecognizersResponse.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListEntityRecognizersCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1ListEntityRecognizersCommand(input, context);
    };
    ListEntityRecognizersCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1ListEntityRecognizersCommand(output, context);
    };
    return ListEntityRecognizersCommand;
}($Command));
export { ListEntityRecognizersCommand };
//# sourceMappingURL=ListEntityRecognizersCommand.js.map